import React from 'react'

import PropTypes from 'prop-types'
import { FaComments, FaPhone, FaSignInAlt } from 'react-icons/fa'
import styled from 'styled-components'

import { personaEnums } from '../../enums'
import usePersona from '../../hooks/usePersona'
import { above, colors } from '../../style/design-system'
import { formatPhoneNumber } from '../../utils/phoneNumberFormatter'
import { UnderlinedAGa } from '../elements/UnderlinedAGoogleAnalytics'
import GetStarted from '../reusables/GetStarted'

const AboveNav = ({ className }) => {
  const { persona } = usePersona()

  const renderCTA = () => {
    return <GetStarted pageLocation="Above Nav" />
  }

  return (
    <section className={className}>
      <div className="container-fluid">
        <div className="left">
          <UnderlinedAGa
            className="portal"
            color="#fff"
            gaLabel="TODO"
            aria-label="Call Ultimate Medical Academy"
            href="/students/puma-den-login/">
            <FaSignInAlt />
            &nbsp;
            <span>Student Portal</span>
          </UnderlinedAGa>
        </div>
        <div className="right">
          <span>
            <UnderlinedAGa
              className="phone"
              color="#fff"
              gaLabel="TODO"
              href={`tel:${persona.phoneNumber}`}>
              <FaPhone />
              &nbsp;
              <span>{formatPhoneNumber(persona.phoneNumber)}</span>
            </UnderlinedAGa>
          </span>
          {persona.name !== personaEnums.personas.WORK_HERE && (
            <div
              className="pointer chat position-relative cta__chat"
              id="liveperson-launcher-top"
              aria-label="Chat now">
              <FaComments />
              &nbsp;
              <span>Chat</span>
            </div>
          )}
          {renderCTA()}
        </div>
      </div>
    </section>
  )
}

AboveNav.propTypes = {
  className: PropTypes.string,
}

AboveNav.defaultProps = {
  className: '',
}

export default styled(AboveNav)`
  display: none;
  ${above.lg`
    display: block;
  `}
  .container-fluid {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    background-color: ${colors.umaDarkGray};
    .phone,
    .portal {
      transform: translateY(-0.25rem);
    }
    .right {
      align-self: stretch;
      display: flex;
      flex-direction: row;
      align-items: center;
      > span {
        margin: 0 1.25rem;
      }
      > div,
      > span {
        display: flex;
        align-items: center;
      }
      .job-board {
        align-self: stretch;
      }
      .enroll-now {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        padding: 0.5rem 1.5rem;
        text-decoration: none;
        font-size: 1.5rem;
      }
    }
  }

  .phone *,
  .chat *,
  .portal * {
    display: inline-block;
    vertical-align: text-bottom;
    line-height: 1;
  }
`

// TODO: Use Aaron's icons instead of Font Awesome icons
// TODO: Assign a ga-label to the phone number link
// TODO: Assign a ga-label to the Chat link
// TODO: Assign a ga-label to the Puma Den link
